module.exports = __webpack_public_path__ + "static/media/baseinfo.333340bb.svg";